"use client"
import classNames from "classnames"
import styles from "../../styles/LandingPage/Patients.module.scss"
import StyledText from "../typography/typography-component"
import Image from "next/image"
import skColors from "../../styles/skColors"
import { useTranslations } from "next-intl"

const Awards = () => {
  const t = useTranslations("index")
  return (
    <div className={classNames(styles.col, styles.awardContainer)}>
      <div className={classNames(styles.row, styles.spaceAround, styles.marginBig)}>
        <StyledText variant={"h2"} color={skColors.turquoise[600]}>
          {t("achievements.title")}
        </StyledText>
      </div>
      <div style={{ alignItems: "baseline" }} className={classNames(styles.row, styles.spaceAround, styles.flwr)}>
        <div className={classNames(styles.col, styles.itemsCenter, styles.spaceAround, styles.awardImageContainer)}>
          <Image
            width={56}
            height={70}
            src={"/images/awards/award.svg"}
            alt={"Bremer Gründerpreis 2024"}
            style={{
              marginBottom: "24px",
              maxWidth: "100%",
              height: "auto",
            }}
          />
          <StyledText className={styles.awardPrice} variant={"tags"} color={skColors.turquoise[600]}>
            {t("achievements.startup.title")}
          </StyledText>
          <StyledText className={styles.awardName} variant={"pRegular"}>
            {t("achievements.startup.subtitle")}
          </StyledText>
        </div>
        <div className={classNames(styles.col, styles.itemsCenter, styles.spaceAround, styles.awardImageContainer)}>
          <Image
            width={56}
            height={70}
            src={"/images/awards/award1.svg"}
            alt={"Campusideen Bremen 2021"}
            style={{
              marginBottom: "24px",
              maxWidth: "100%",
              height: "auto",
            }}
          />
          <StyledText className={styles.awardPrice} variant={"tags"} color={skColors.turquoise[600]}>
            {t("achievements.platz1.title")}
          </StyledText>
          <StyledText className={styles.awardName} variant={"pRegular"}>
            {t("achievements.platz1.subtitle")}
          </StyledText>
        </div>
        <div className={classNames(styles.col, styles.itemsCenter, styles.spaceAround, styles.awardImageContainer)}>
          <Image
            width={56}
            height={70}
            src={"/images/awards/award1.svg"}
            alt={"nTT Data eAward 2022"}
            style={{
              marginBottom: "24px",
              maxWidth: "100%",
              height: "auto",
            }}
          />
          <StyledText className={styles.awardPrice} variant={"tags"} color={skColors.turquoise[600]}>
            {t("achievements.platz2.title")}
          </StyledText>
          <StyledText className={styles.awardName} variant={"pRegular"}>
            {t("achievements.platz2.subtitle")}
          </StyledText>
        </div>
        <div className={classNames(styles.col, styles.itemsCenter, styles.spaceAround, styles.awardImageContainer)}>
          <Image
            width={56}
            height={70}
            src={"/images/awards/award1.svg"}
            alt={"eAward by NTT DACH"}
            style={{
              marginBottom: "24px",
              maxWidth: "100%",
              height: "auto",
            }}
          />
          <StyledText className={styles.awardPrice} variant={"tags"} color={skColors.turquoise[600]}>
            {t("achievements.platz3.title")}
          </StyledText>
          <StyledText className={styles.awardName} variant={"pRegular"}>
            {t("achievements.platz3.subtitle")}
          </StyledText>
        </div>
      </div>
    </div>
  )
}

export default Awards
